import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useAuditLog = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest, isLoading, error, setError } = useHttp();

  const getAuditLogById = useCallback(
    async (auditLogId, { includePatch = true, includeDiff = true } = {}) => {
      try {
        const response = await sendRequest({
          url: `/api/v1/auditLog/${auditLogId}`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
          params: {
            includePatch: includePatch ? 'true' : 'false',
            includeDiff: includeDiff ? 'true' : 'false',
          },
        });
        return response;
      } catch (err) {
        toast.error('Fehler beim Laden des Audit-Log-Details');
        throw err;
      }
    },
    [authCtx, sendRequest]
  );

  return {
    isLoading,
    error,
    setError,
    getAuditLogById,
  };
};

export default useAuditLog;

